import type {LucideIcon} from "lucide-react";
import {RoleList, UserRole} from "../../../core/roles/roles.type";
import {User, ClipboardList, Settings, FileText, LogOut, PartyPopper, NotebookPen, FolderOpen} from "lucide-react";

export interface DropdownItem {
    id: string;
    label: string;
    icon: LucideIcon;
    roles: RoleList;
    onClick: (
        navigate: (path: string) => void,
        logout: () => void,
        role: UserRole,
    ) => void;
    groupEnd?: true;
    disabled?: boolean;
    badge?: string;
}

const ALL: RoleList = ["ADMIN", "EMPLOYEE", "HR"];
const ADM: RoleList = ["ADMIN"];
const EMP_HR: RoleList = ["EMPLOYEE", "HR"];

export const DROPDOWN_ITEMS: DropdownItem[] = [
    {
        id: "profile",
        label: "Profile",
        icon: User,
        roles: EMP_HR,
        onClick: (navigate) => navigate("/my-profile")
    },
    {
        id: "my-notes",
        label: "My Notes",
        icon: NotebookPen,
        roles: ALL,
        onClick: (navigate) => navigate("/my-notes"),
    },
    {
        id: "events",
        label: "Events",
        icon: PartyPopper,
        roles: ADM,
        onClick: (navigate) => navigate("/highlights/our-events"),
    },
    {
        id: "attendance",
        label: "Attendance",
        icon: ClipboardList,
        roles: ALL,
        onClick: (navigate, _, role: UserRole) => navigate(role === "ADMIN" ? "/employee/attendance" : "/my/attendance"),
    },
    // {
    //     id: "punch-records",
    //     label: "Punch Records",
    //     icon: Clock,
    //     roles: EMP_HR,
    //     onClick: (navigate) => navigate("/employee/punch-records"),
    //     groupEnd: true,
    // },
    {
        id: "leave-summary",
        label: "Leave Summary",
        icon: FileText,
        roles: EMP_HR,
        onClick: (navigate) => navigate("/time-off/leaves/summary"),
    },
    {
        id: "manage-asset",
        label: "Asset Management",
        icon: FolderOpen,
        roles: ADM,
        onClick: (navigate) => navigate("/asset/dashboard"),
    },
    {
        id: "change-password",
        label: "Change Password",
        icon: Settings,
        roles: ALL,
        onClick: (navigate) => navigate("/user/reset-password"),
        groupEnd: true,
    },
    {
        id: "logout",
        label: "Log Out",
        icon: LogOut,
        roles: ALL,
        onClick: (_, logout) => logout(),
    },
];

export function getDropdownItems(role: UserRole): DropdownItem[] {
    return DROPDOWN_ITEMS.filter(item => item.roles.includes(role));
}

export const ROLE_STYLE: Record<UserRole, { bg: string; border: string; text: string }> = {
    ADMIN: {
        bg: "rgba(56,189,248,0.15)",
        border: "rgba(56,189,248,0.35)",
        text: "#38BDF8"
    },
    EMPLOYEE: {
        bg: "rgba(52,211,153,0.15)",
        border: "rgba(52,211,153,0.35)",
        text: "#34D399"
    },
    HR: {
        bg: "rgba(236,72,153,0.15)",
        border: "rgba(236,72,153,0.35)",
        text: "#EC4899"
    },
    USER: {
        bg: "rgba(249,115,22,0.15)",
        border: "rgba(249,115,22,0.35)",
        text: "#F97316"
    }
};